import { type ComponentPropsWithoutRef, memo } from 'react';

import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';
import { Tooltip } from '@air/primitive-tooltip';
import { cn } from '@air/utils-tailwind';

export type GalleryAssetTitleProps = Omit<ComponentPropsWithoutRef<'button'>, 'children'> & {
  clip: Clip | PublicClip;
};

export const GalleryAssetTitle = memo(({ className, clip, ...restOfProps }: GalleryAssetTitleProps) => {
  const title = clip.title || clip.importedName || 'Untitled';

  return (
    <Tooltip label={title} side="top" sideOffset={4}>
      <button
        data-testid="ASSET_CARD_TITLE"
        className={cn(
          'pointer-events-auto truncate text-left font-medium ads:text-primary text-16 text-gray-12 outline-none hover:underline ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9',
          className,
        )}
        {...restOfProps}
      >
        {title}
      </button>
    </Tooltip>
  );
});

GalleryAssetTitle.displayName = 'GalleryAssetTitle';
